function fezoraInitAllStoryCarousels(root) {
  (root || document).querySelectorAll('[data-fezora-story-carousel]').forEach(function (section) {
    if (section.dataset.fezoraInitialized) return;
    section.dataset.fezoraInitialized = 'true';
    initFezoraStoryCarousel(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    fezoraInitAllStoryCarousels(document);
  });
} else {
  fezoraInitAllStoryCarousels(document);
}

document.addEventListener('shopify:section:load', function (event) {
  fezoraInitAllStoryCarousels(event.target);
});

function initFezoraStoryCarousel(section) {
  var media = section.querySelector('[data-fezora-story-media]');
  var textWrap = section.querySelector('[data-fezora-story-text]');
  var prevBtn = section.querySelector('[data-fezora-story-prev]');
  var nextBtn = section.querySelector('[data-fezora-story-next]');
  var dotsWrap = section.querySelector('[data-fezora-story-dots]');
  if (!media || !textWrap) return;

  var images = Array.prototype.slice.call(media.querySelectorAll('.fezora-story-carousel__slide-image'));
  var texts = Array.prototype.slice.call(textWrap.querySelectorAll('[data-slide-index]'));
  var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-slide-index]')) : [];
  var bgs = Array.prototype.slice.call(section.querySelectorAll('.fezora-story-carousel__bg[data-slide-index]'));
  var total = images.length;

  var current = 0;
  var autoplayMs = parseInt(section.dataset.autoplayMs, 10) || 0;
  var loopsPerVideo = Math.max(1, parseInt(section.dataset.loopsPerVideo, 10) || 3);
  var timer = null;
  var inView = true;
  var hovering = false;
  var editorLock = false;
  var loopCount = 0;
  var pauseTimers = [];
  var lastTimes = [];

  /* ---------- Videos: silent loop, always restart from 0 when their slide becomes active ---------- */
  var videos = images.map(function (el) {
    var v = el.querySelector('video');
    if (v) {
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.controls = false;
      v.addEventListener('ended', function () {
        v.currentTime = 0;
        safePlay(v);
      });
    }
    return v;
  });

  function safePlay(v) {
    if (!v) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function syncVideos(restart) {
    videos.forEach(function (v, i) {
      if (!v) return;
      clearTimeout(pauseTimers[i]);
      if (i === current && inView) {
        if (restart) {
          try { v.currentTime = 0; } catch (e) {}
          lastTimes[i] = 0;
        }
        safePlay(v);
      } else {
        // let the outgoing slide finish fading before freezing it
        pauseTimers[i] = setTimeout(function () { v.pause(); }, 750);
      }
    });
  }

  /* Count full loops of the visible video: a loop is completed when currentTime jumps back near 0 */
  videos.forEach(function (v, i) {
    if (!v) return;
    lastTimes[i] = 0;
    v.addEventListener('timeupdate', function () {
      var t = v.currentTime;
      if (i === current && t + 0.5 < lastTimes[i]) {
        loopCount += 1;
        if (autoplayMs > 0 && loopCount >= loopsPerVideo) tryAdvance();
      }
      lastTimes[i] = t;
    });
  });

  /* ---------- Slide navigation ---------- */
  function goTo(index) {
    var target = ((index % total) + total) % total;
    images.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === target);
    });
    texts.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === target);
    });
    dots.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === target);
    });
    bgs.forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === target);
    });
    current = target;

    // Safety net: if nothing ended up active for any reason, force the first slide visible
    var anyImageActive = images.some(function (el) { return el.classList.contains('is-active'); });
    var anyTextActive = texts.some(function (el) { return el.classList.contains('is-active'); });
    if (!anyImageActive || !anyTextActive) {
      images.forEach(function (el, i) { el.classList.toggle('is-active', i === 0); });
      texts.forEach(function (el, i) { el.classList.toggle('is-active', i === 0); });
      dots.forEach(function (el, i) { el.classList.toggle('is-active', i === 0); });
      bgs.forEach(function (el, i) { el.classList.toggle('is-active', i === 0); });
      current = 0;
    }

    loopCount = 0;
    syncVideos(true);
    armTimer();
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  /* ---------- Autoplay ----------
     - Image slides: advance after `autoplay_seconds`.
     - Video slides: advance right after the LAST of N loops finishes (see timeupdate above),
       so a spin is never cut in half. The timer below is only a safety net in case the
       video can't play (e.g. low-power mode blocks autoplay), so the carousel never gets stuck. */
  function tryAdvance() {
    if (hovering || editorLock || !inView) return;
    next();
  }

  function disarmTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function armTimer() {
    disarmTimer();
    if (autoplayMs <= 0 || total <= 1 || editorLock || hovering) return;
    var ms = autoplayMs;
    var v = videos[current];
    if (v) {
      var dur = isFinite(v.duration) && v.duration > 0 ? v.duration : 5;
      ms = Math.max(autoplayMs, dur * loopsPerVideo * 1000) + 3000;
    }
    timer = setTimeout(function () {
      timer = null;
      tryAdvance();
    }, ms);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      syncVideos(false);
      if (inView) armTimer(); else disarmTimer();
    }, { threshold: 0.15 }).observe(section);
  }

  syncVideos(true);

  if (total <= 1) return;

  if (nextBtn) nextBtn.addEventListener('click', next);
  if (prevBtn) prevBtn.addEventListener('click', prev);

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.slideIndex, 10));
    });
  });

  // Pause advancing while a mouse hovers the section (videos keep spinning). Ignore touch taps.
  section.addEventListener('pointerenter', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    hovering = true;
    disarmTimer();
  });
  section.addEventListener('pointerleave', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    hovering = false;
    loopCount = 0;
    armTimer();
  });

  // Theme editor: selecting a slide block jumps to it and holds autoplay
  document.addEventListener('shopify:block:select', function (event) {
    if (!section.contains(event.target)) return;
    editorLock = true;
    var idx = parseInt(event.target.dataset.slideIndex, 10);
    if (!isNaN(idx)) goTo(idx);
    disarmTimer();
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    if (!section.contains(event.target)) return;
    editorLock = false;
    loopCount = 0;
    armTimer();
  });

  armTimer();
}
